import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_ENDPOINT;

const handleLogout = () => {
    localStorage.removeItem('currentUser')
    localStorage.removeItem('token')
    localStorage.removeItem('tabIndex')
    localStorage.clear();
    // Redirect to login page
    window.location.href = '/';
};

// Create an Axios instance
const api = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add a request interceptor
api.interceptors.request.use(
    (config) => {
        // Get the token from localStorage
        const token = localStorage.getItem('token');

        // If the token exists, add it to the headers
        if (token) {
            config.headers.authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        // Handle the error
        return Promise.reject(error);
    }
);

const handle401Error = (error) => {
    if (error.response && error.response.status === 401) {
        handleLogout();
    }
    return Promise.reject(error);
};

// Add response interceptor to api instance
api.interceptors.response.use(
    (response) => response,
    handle401Error
);

// For multipart/form-data requests
const formApi = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'multipart/form-data',
    },
});

// Add a request interceptor to formApi
formApi.interceptors.request.use(
    (config) => {
        // Get the token from localStorage
        const token = localStorage.getItem('x-access-token');

        // If the token exists, add it to the headers
        if (token) {
            config.headers.authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        // Handle the error
        return Promise.reject(error);
    }
);



formApi.interceptors.response.use(
    (response) => response,
    handle401Error
);

export const doCreateFolder = async (payload) => {
    try {
        const { data } = await api.post(`${BASE_URL}folder/create`, payload);
        return data;
    } catch (error) {
        return error
    }
};


export const doFindFolder = async () => {
    try {
        const { data } = await api.get(`${BASE_URL}folder/find`);
        return data;
    } catch (error) {
        return error
    }
}


export const doRenameFolder = async (id,payload) => {
    try {
        const { data } = await api.patch(`${BASE_URL}folder/update/${id}`,payload)
        return data
    } catch (error) {
        return error

    }
}

export const doDeleteFolder = async (id) => {
    try {
        const { data } = await api.delete(`${BASE_URL}folder/delete/${id}`)
        return data
    } catch (error) {
        return error

    }
}